import { clientFetch } from '../clientFetch';

/*
 * Parameters:
 * projectId
 * personId
 * size
 * page (0 based)
 * specialty
 * insurance
 * lat
 * lon
 * fidelity
 * radius
 * country
 * state
 *
 */
export const doctorSearchResults = (body, signal) => {
  return clientFetch(body.type ? `/search/doctors/${body.type}` : `/search/doctors/`, { method: 'POST', body, signal });
};

export const doctorSearch = (body) => {
  return clientFetch(body.type ? `/search/doctors/${body.type}` : `/search/doctors/`, { method: 'POST', body });
};
